import { render, staticRenderFns } from "./ScoringV2.vue?vue&type=template&id=6d660ffa&scoped=true&"
import script from "./ScoringV2.vue?vue&type=script&lang=ts&"
export * from "./ScoringV2.vue?vue&type=script&lang=ts&"
import style0 from "./ScoringV2.vue?vue&type=style&index=0&id=6d660ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d660ffa",
  null
  
)

export default component.exports